var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 43,
    viewBox: "0 0 36 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 22.5V11.1C33 7.73969 33 6.05953 32.346 4.77606C31.7708 3.64708 30.8529 2.7292 29.7239 2.15396C28.4405 1.5 26.7603 1.5 23.4 1.5H10.6C7.23969 1.5 5.55953 1.5 4.27606 2.15396C3.14708 2.7292 2.2292 3.64708 1.65396 4.77606C1 6.05953 1 7.73969 1 11.1V31.9C1 35.2603 1 36.9405 1.65396 38.2239C2.2292 39.3529 3.14708 40.2708 4.27606 40.846C5.55953 41.5 7.23969 41.5 10.6 41.5H17M21 19.5H9M13 27.5H9M25 11.5H9M22 35.5L26 39.5L35 30.5",
    stroke: "#202D66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCheck);
export default __webpack_public_path__ + "static/media/file-check.00c4cdaec2e39f29d50dff4dc6777a69.svg";
export { ForwardRef as ReactComponent };